define('views/components/product_category/product_category_list',['require','views/base/list_view','views/components/product_category/product_category','text!templates/components/product_category/product_category_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/product_category/product_category');

    var temp = require("text!templates/components/product_category/product_category_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

